import { useState, useEffect } from 'react';
import '../styles/carousel.css';
import ImageA from '../../assets/carousel-1-fix.JPEG';
import ImageB from '../../assets/carousel-2-fix.jpeg';
import ImageC from '../../assets/carousel-3-fix.JPG';
import { useLanguage } from '../../contexts/LanguageContext';
import { highlightIndonesiaLestari } from '../../utils/textHelper'; // ✅ import helper

const images = [
  {
    src: ImageA,
    alt: 'Gambar 1',
    text: {
      en: '',
      id: 'Mendorong kepedulian publik demi sistem persampahan yang lebih baik'
    }
  },
  {
    src: ImageB,
    alt: 'Gambar 2',
    text: {
      en: '',
      id: 'Jaga lingkungan adalah bentuk bela negara'
    }
  },
  {
    src: ImageC,
    alt: 'Gambar 3',
    text: {
      en: '',
      id: 'Forum yang memoderasi diskusi konstruktif dan non-partisan, dari seluruh pihak di Indonesia'
    }
  }
];

const Carousel = () => {
  const { language } = useLanguage();
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 6500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="carousel-container">
      <div key={currentIndex} className="carousel-slide">

        <img
          src={images[currentIndex].src}
          alt={images[currentIndex].alt}
          className="carousel-image"
        />

        <div className="carousel-text">
          {highlightIndonesiaLestari(images[currentIndex].text[language])}
        </div>

        <button className="carousel-btn prev" onClick={prevSlide}>&#10094;</button>
        <button className="carousel-btn next" onClick={nextSlide}>&#10095;</button>

      </div>

      <div className="carousel-indicators">
        {images.map((_, index) => (
          <span
            key={index}
            className={`indicator-dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => setCurrentIndex(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default Carousel;
